@if (commandContent()) {
  <table class="table table-sm table-list mb-4">
    <thead>
      <tr>
        <th colspan="2"
            scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>CommandUUID:</td>
        <td>{{commandContent()?.commandUUID}}</td>
      </tr>
      @for (entry of commandContent().command | keyvalue; track entry) {
        <tr>
          <td>{{entry.key}}:</td>
          <td>
            <ml-timeline-command-payload [commandContentKey]="entry.key"
                                         [commandContentEntry]="entry.value"></ml-timeline-command-payload>
          </td>
        </tr>
      }
    </tbody>
  </table>
} @else {
  <ml-sk-spinner-3></ml-sk-spinner-3>
}